export const
  immq = (qs, el=document) => el.querySelectorAll(qs),
  immq1 = (qs, el=document) => el.querySelector(qs)
